import React from "react";

const ExperienceCard = ({
  logo,
  title,
  company,
  location,
  duration,
  bullets = [],
  note, // optional field
}) => {
  return (
    <div
      className="bg-white rounded-xl shadow-lg flex flex-col md:flex-row overflow-hidden w-full md:w-3/5 mx-auto mb-4
                    transform transition-transform duration-300 hover:scale-102"
    >
      {/* Left: Logo / Photo */}
      <div className="flex-shrink-0 w-full md:w-1/4 bg-text-dark-default flex items-center justify-center p-4">
        <img
          src={logo}
          alt={`${company} logo`}
          className="max-h-32 md:max-h-40 object-contain"
        />
      </div>

      {/* Right: Text */}
      <div className="flex-1 p-6 flex flex-col justify-between bg-text-default">
        {/* Header: Title / Company + Location / Duration */}
        <div className="flex flex-col md:flex-row md:justify-between mb-4">
          <div>
            <h3 className="text-xl font-bold">{title}</h3>
            <p className="text-color-sub">{company}</p>
          </div>
          <div className="text-color-sub mt-2 md:mt-0 text-right">
            <p>{location}</p>
            <p>{duration}</p>
          </div>
        </div>

        {/* Bullet points */}
        <ul className="list-disc text-color-default space-y-2 ml-4">
          {bullets.map((bullet, index) => (
            <li
              key={index}
              className="transition-colors duration-200 hover:text-gray-500"
            >
              {bullet}
            </li>
          ))}
        </ul>

        {/* Optional note */}
        {note && (
          <div className="mt-4 bg-yellow-100 p-4 rounded-lg text-sm">
            {note}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExperienceCard;
